"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const Icon = ({ size = _1.IconSize.Medium, color = _1.IconColor.DigitalBlack, name = _1.IconName.CarlsbergFilled, viewBox, className, onClick }) => {
    const IconElement = _1.IconsPaths[name];
    return (react_1.default.createElement(IconElement, { viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : '0 0 24 24', className: className, color: color, size: size, onClick: onClick, name: name }));
};
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map